export default __webpack_public_path__ + "static/media/wine.08e49fdc.jpg";